<div class="feature-work section-gap bg-light">
  <div class="container">
    <div class="section-title-wrapper mb-5">
      <div class="row">
        <div class="col-sm-12 col-md-10 mx-auto text-center">
          <div class="d-flex align-items-center justify-content-center">
            <app-badges [badges]="titleConfigurations.badges"></app-badges>
          </div>

          <div class="d-flex align-items-center">
            <h2 [id]="titleConfigurations.title | stripSpecialChars">
              <app-dynamic-content
                [contentId]="'color-list-title'"
                [htmlContent]="titleConfigurations.title">
              </app-dynamic-content>
            </h2>
            <kla-social-media-buttons class="mb-2" [linkFragment]="titleConfigurations.title"></kla-social-media-buttons>
          </div>
          <app-dynamic-content
            [contentId]="'color-list-desc'"
            [htmlContent]="titleConfigurations.description">
          </app-dynamic-content>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-3" *ngFor="let item of config.list">
        <div class="card-line-box  p-4">
          <div class="mb-4">
            <div class="icon-container">
              <i *ngIf="item.icon" [class]="'icon-' + item.icon + ' pr-5'" [ngStyle]="{'color': item.buttonColor}"></i>
            </div>
          </div>
          <h5 class="mb-3">{{item.title}}</h5>
          <app-dynamic-content
            [contentId]="'color-list-button'"
            [htmlContent]="item.button">
          </app-dynamic-content>
        </div>
      </div>
    </div>
  </div>
</div>
